import './App.css';
import {Route} from "react-router-dom";
import {HomePage} from './views/HomePage';
import {ResearchQuestionsConnector} from "./connectors/ResearchQuestionsConnector";
import {ResearcherPageConnector} from "./connectors/ResearcherPageConnector";
import {IndividualReport} from "./views/IndividualReport";

function App() {
    return (
        <div className="App">
            <Route exact path="/" component={HomePage}/>
            <Route exact path="/participate" component={ResearchQuestionsConnector}/>
            <Route exact path="/participate/research-questions" component={ResearchQuestionsConnector}/>
            <Route exact path="/researcher" component={ResearcherPageConnector}/>
            <Route exact path="/user-report" component={IndividualReport}/>
        </div>
    );
}

export default App;
